import { $_app_server } from '@/_helpers'

export const knowledgebaseService = {
  getKnowledgeCategory,
  getKnowledgeDocs,
  addKnowledgeDoc,
  editKnowledgeDoc,
  delKnowledgeDoc,
  getFile
}

function getKnowledgeCategory () {
  return $_app_server.get('knowledge/tree').then(response => response.data)
}

function getKnowledgeDocs (filter) {
  return $_app_server.post('knowledge/docs',filter).then(response => response.data)
}

function addKnowledgeDoc (data) {
  return $_app_server.post('knowledge/'+data.cat+'/doc',data.doc).then(response => response.data)
}

function editKnowledgeDoc (data) {
  return $_app_server.put('knowledge/doc',data).then(response => response.data)
}

function delKnowledgeDoc (data) {
  return $_app_server.delete('knowledge/doc/'+data.id,).then(response => response.data)
}

function getFile (filename) {
  return $_app_server.get('/files/'+filename).then(response => response.data)
}